<template>
    <div class="container_view">
        <v-card class="content_card" elevation="10" variant="flat">
            <header>
                <v-card-title> Gestión de Documentos </v-card-title>
                <v-divider class="mx-3"></v-divider>
            </header>
            <div class="content_accion">
                <div style="display: flex;">
                    <v-text-field
                        v-model="search"
                        label="Búsqueda"
                        prepend-inner-icon="mdi-magnify"
                        single-line
                        variant="outlined"
                        hide-details
                        class="filter mr-2"
                    ></v-text-field>
                        
                    <v-autocomplete
                        v-if="typeUser === 'Supervisor' || typeUser === 'Administrador' "
                        label="Seleccione un usuario"
                        v-model="formFilter"
                        prepend-inner-icon="mdi-account"
                        :items="arrUsers"
                        item-title="usuario"
                        item-value="id"
                        variant="outlined"
                        class="filter"
                        single-line
                        hide-details
                        @update:model-value="getProgressByUser()"
                    ></v-autocomplete>
                </div>
                <div>
                    <v-tooltip text="Recargar" location="bottom">
                        <template v-slot:activator="{ props }">
                            <v-btn 
                                v-bind="props"
                                class="mr-2"
                                size="small" 
                                icon="mdi-reload" 
                                variant="outlined" 
                                color="indigo-darken-3" 
                                @click="getDocuments()"
                            ></v-btn>
                        </template>
                    </v-tooltip>
                    <v-btn 
                        v-if="permission.addDocument"
                        prepend-icon="mdi-plus" 
                        color="indigo-darken-3"
                        class="elevation-0 text-none mr-2"
                        text="Registrar"
                        @click="openForm('R')"
                    ></v-btn>
                    <v-tooltip text="Configuración" location="bottom">
                        <template v-slot:activator="{ props }">
                            <v-btn 
                                v-if="permission.managementCategory || permission.managementSubcategory"
                                id="menu-activator"
                                v-bind="props"
                                class="mr-2 elevation-0"
                                size="small" 
                                icon="mdi-cog" 
                                color="blue-grey-lighten-1" 
                            ></v-btn>
                            <v-menu activator="#menu-activator">
                                <v-list>
                                    <v-list-item v-if="permission.managementCategory">
                                        <v-list-item-title @click="$router.push('/SGCCV/documents/category')">
                                            Gestión de Categorías
                                        </v-list-item-title>
                                    </v-list-item>
                                    <v-list-item v-if="permission.managementSubcategory">
                                        <v-list-item-title @click="$router.push('/SGCCV/documents/subcategory')">
                                            Gestión de Subcategorías
                                        </v-list-item-title>
                                    </v-list-item>
                                </v-list>
                            </v-menu>
                        </template>
                    </v-tooltip>
                </div>
            </div>

            <div class="container_table" v-if="this.formFilter === null">
                <v-data-table
                    :headers="dataSource.headers"
                    :items="dataSource.data"
                    :search="search"
                    :loading="isLoading"
                    fixed-header
                    class="content_table"
                    no-data-text="Sin datos para mostrar"
                    loading-text="Cargando información... Espere un momento"
                >
                    <template v-slot:[`item.actions`]="{ item }">
                        <td>
                            <v-tooltip text="Descargar" location="bottom">
                                <template v-slot:activator="{ props }">
                                    <v-btn
                                        v-bind="props"
                                        class="elevation-0 mr-1"
                                        density="comfortable" 
                                        icon="mdi-file-download" 
                                        color="indigo-darken-3" 
                                        @click="confirmateDownload(item)"
                                    ></v-btn>
                                </template>
                            </v-tooltip>
                            <v-tooltip text="Eliminar" location="bottom">
                                <template v-slot:activator="{ props }">
                                    <v-btn
                                        v-if="permission.deleteDocument"
                                        v-bind="props"
                                        class="elevation-0"
                                        density="comfortable" 
                                        icon="mdi-delete" 
                                        color="error" 
                                        @click="confirmateDelete(item)"
                                    ></v-btn>
                                </template>
                            </v-tooltip>
                        </td>
                    </template>
                </v-data-table>
            </div>

            <div class="container_table" v-if="this.formFilter !== null">
                <v-data-table
                    :headers="dataSourceProcess.headers"
                    :items="dataSourceProcess.data"
                    :search="search"
                    :loading="isLoading"
                    fixed-header
                    class="content_table"
                    no-data-text="Sin datos para mostrar"
                    loading-text="Cargando información... Espere un momento"
                >
                    <template v-slot:[`item.estado`]="{ item }">
                        <td>
                            <v-chip variant="flat" v-if="item.estado === 'Pendiente'">
                                {{ item.estado }}
                            </v-chip>
                            <v-chip color="green" variant="flat" v-if="item.estado === 'Revisado'">
                                {{ item.estado }}
                            </v-chip>
                        </td>
                    </template>
                    <template v-slot:[`item.actions`]="{ item }">
                        <td>
                            <v-tooltip text="Descargar" location="bottom">
                                <template v-slot:activator="{ props }">
                                    <v-btn
                                        v-bind="props"
                                        class="elevation-0 mr-1"
                                        density="comfortable" 
                                        icon="mdi-file-download" 
                                        color="indigo-darken-3" 
                                        @click="confirmateDownload(item)"
                                    ></v-btn>
                                </template>
                            </v-tooltip>
                        </td>
                    </template>
                </v-data-table>
            </div>
        </v-card>

        <template>
            <v-dialog
                v-model="dataDialogForm.open"
                activator="parent"
                persistent
                width="500px">
                <v-card>
                    <header>
                        <v-card-title class="text-h5">Registro de Documento</v-card-title>
                        <v-divider class="mx-3"></v-divider>
                    </header>
                    <form class="mt-4 px-4 override_content_flex">
                        <div class="col-flex-12">
                            <v-text-field
                                label="Nombre documento" 
                                v-model="formGroup.data.nombreDocumento"
                                :rules="formGroup.rules.nombreDocumento"
                                variant="outlined"                                
                                class="w-100"                               
                            ></v-text-field>
                        </div>
                        <div class="col-flex-12">
                            <v-select
                                label="Categoría" 
                                v-model="formGroup.data.id_categoria"
                                :rules="formGroup.rules.id_categoria"
                                variant="outlined"
                                :items="arrCategory"
                                item-title="nombre_categoria"
                                item-value="id_categoria"
                                class="w-100"
                                @update:model-value="getSubcategoriesByCategory()"
                            ></v-select>
                        </div>
                        <div class="col-flex-12">
                            <v-select
                                v-if="isLoadingSubcategory === false"
                                label="Subcategoría" 
                                v-model="formGroup.data.id_subcategoria"
                                :rules="formGroup.rules.id_subcategoria"
                                variant="outlined"
                                :items="arrSubcategory"
                                :disabled="formGroup.data.id_categoria === null || arrSubcategory.length === 0"
                                item-title="nombre_subcategoria"
                                item-value="id_subcategoria"
                                class="w-100">
                            </v-select>
                            <div v-if="isLoadingSubcategory === true" style="height: 78px; display: flex; align-items: center">
                                <v-progress-linear color="indigo-darken-3" indeterminate></v-progress-linear>
                            </div>
                        </div>
                        <div class="col-flex-12">
                            <v-select
                            label="Perfiles" 
                            v-model="formGroup.data.perfiles"
                            :rules="formGroup.rules.perfiles"
                            variant="outlined"
                            :items="arrProfiles"
                            item-title="title"
                            item-value="value"
                            multiple
                            class="w-100"
                            @update:model-value="getSubcategoriesByCategory()"
                            ></v-select>
                        </div>
                        <div class="col-flex-12">
                            <v-file-input 
                                label="Archivo" 
                                v-model="formGroup.data.archivo"
                                :rules="formGroup.rules.archivo"
                                variant="outlined"
                                prepend-icon=""
                                append-inner-icon="mdi-file-upload"
                            ></v-file-input>
                        </div>
                    </form>
                    <v-card-actions class="actions_buttons">
                        <v-btn 
                            variant="flat"
                            color="red"
                            class="text-none"
                            text="Cerrar"
                            prepend-icon="mdi-close"
                            @click="clearForm()">
                            Cerrar
                        </v-btn>
                        <v-btn 
                            variant="flat"
                            color="indigo-darken-3"
                            class="text-none"
                            text="Guardar"
                            prepend-icon="mdi-content-save"
                            :disabled="validateForm()"
                            @click="saveForm()"
                        ></v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </template>

        <template>
            <v-dialog v-model="dataDialogSave.open" width="auto" persistent>
                <v-card>
                    <v-card-title text-h5>{{ dataDialogSave.title }}</v-card-title>
                    <v-card-text>
                        <div class="text-center alert_img" v-if="!dataDialogSave.loading">
                            <img src="@/assets/images/warning.png">
                        </div>
                        <div class="content_load" v-if="dataDialogSave.loading">
                            <v-progress-circular
                                :size="100"
                                :width="7"
                                color="indigo-darken-3"
                                indeterminate
                            ></v-progress-circular>
                            <i>Espere un momento</i>
                        </div>

                        <div class="description-text">
                            <p>{{ dataDialogSave.description }}</p>
                        </div>
                    </v-card-text>
                    <v-card-actions class="actions_buttons_confirmation" v-if="!dataDialogSave.loading">
                        <v-btn 
                            variant="flat"
                            color="red"
                            class="text-none"
                            text="Cancelar"
                            prepend-icon="mdi-cancel"
                            @click="clearForm()"
                        ></v-btn>
                        <v-btn 
                            variant="flat"
                            color="indigo-darken-3"
                            class="text-none"
                            text="Aceptar"
                            prepend-icon="mdi-check"
                            @click="confirmateForm()"
                        ></v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>                
        </template>

        <template>
            <v-dialog v-model="dataAlertDelete.open" width="auto" persistent>
                <v-card>
                    <v-card-title text-h5>Confirmación</v-card-title>
                    <v-card-text>
                        <div class="text-center alert_img" v-if="!dataAlertDelete.loading">
                            <img src="@/assets/images/warning.png">
                        </div>
                        <div class="content_load" v-if="dataAlertDelete.loading">
                            <v-progress-circular
                                :size="100"
                                :width="7"
                                color="indigo-darken-3"
                                indeterminate
                            ></v-progress-circular>
                            <i>Espere un momento</i>
                        </div>

                        <div class="description-text">
                            <p>¿Está seguro de eliminar el documento?</p>
                        </div>
                    </v-card-text>
                    <v-card-actions class="actions_buttons_confirmation">
                        <v-btn 
                            variant="flat"
                            color="red"
                            class="text-none"
                            text="Cancelar"
                            prepend-icon="mdi-cancel"
                            @click="dataAlertDelete.open = false"
                        ></v-btn>
                        <v-btn 
                            variant="flat"
                            color="indigo-darken-3"
                            class="text-none"
                            text="Aceptar"
                            prepend-icon="mdi-check"
                            @click="deleteDocument()"
                        ></v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </template>

        <template>
            <v-dialog v-model="dataAlertDownload.open" width="auto" persistent>
                <v-card>
                    <v-card-title text-h5>Confirmación</v-card-title>
                    <v-card-text>
                        <div class="text-center alert_img" v-if="!dataAlertDelete.loading">
                            <img src="@/assets/images/warning.png">
                        </div>
                        <div class="content_load" v-if="dataAlertDelete.loading">
                            <v-progress-circular
                                :size="100"
                                :width="7"
                                color="indigo-darken-3"
                                indeterminate
                            ></v-progress-circular>
                            <i>Espere un momento</i>
                        </div>

                        <div class="description-text">
                            <p>¿Está seguro de descargar el documento?</p>
                        </div>
                    </v-card-text>
                    <v-card-actions class="actions_buttons_confirmation">
                        <v-btn 
                            variant="flat"
                            color="red"
                            class="text-none"
                            text="Cancelar"
                            prepend-icon="mdi-cancel"
                            @click="dataAlertDownload.open = false"
                        ></v-btn>
                        <v-btn 
                            variant="flat"
                            color="indigo-darken-3"
                            class="text-none"
                            text="Descargar"
                            prepend-icon="mdi-check"
                            @click="getDocumentURL()"
                        ></v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>                
        </template>

        <SnackbarComponent :value="snackbarData"/>
    </div>
    
</template>

<script>
import { DocumentsService } from '@/services/DocumentsService'
import { EncryptService } from '@/services/EncryptService'
import { NoticeService } from '@/services/NoticesService'

export default {
    name: "DocumentView",
    props: {
        msg: String,
    },
    data() {
        return {
            search: '',
            isLoading: false,
            isLoadingSubcategory: false,
            formGroup: {
                data:{
                    id_categoria: null,
                    id_subcategoria: null,
                    perfiles: null,
                    archivo: null,
                    nombreDocumento: null
                },
                rules: {
                    id_categoria: [
                        value => {
                            if (value === null || value === '' || value === undefined) {
                                return `El campo Categoría es requerido`
                            }
                        }
                    ],
                    id_subcategoria: [
                        value => {
                            if (value === null || value === '' || value === undefined) {
                                return `El campo Subcategoría es requerido`
                            }
                        }
                    ],
                    perfiles: [
                        value => {
                            if (value === null || value === '' || value === undefined) {
                                return `El campo Perfiles es requerido`
                            }
                        }
                    ],
                    archivo: [
                        value => {
                            if (value === null || value === '' || value === undefined) {
                                return `El campo Archivo es requerido`
                            }
                        }
                    ],
                    nombreDocumento: [
                        value => {
                            if (value === null || value === '' || value === undefined) {
                                return `El campo Nombre es requerido`
                            }
                        }
                    ]
                }
            },
            formFilter: null,
            dataSource: {
                data: [],
                headers: [
                    { 
                        align: 'start',
                        key: 'nombre_categoria', 
                        title: 'Categoría' 
                    },
                    { 
                        key: 'nombre_subcategoria', 
                        title: 'Subcategoría' 
                    },
                    { 
                        key: 'nombre', 
                        title: 'Nombre del Documento' 
                    },
                    { 
                        key: 'perfiles', 
                        title: 'Perfiles' 
                    },
                    { 
                        key: 'agregado_por', 
                        title: 'Última Actualización' 
                    },
                    { 
                        key: 'created_at', 
                        title: 'Fecha de Actualización' 
                    },
                    { 
                        key: 'actions', 
                        title: 'Acciones' 
                    },
                ],
            },
            arrProfiles: [
                { title: 'Supervisor', value: 'Supervisor' },
                { title: 'Gestor', value: 'Gestor' },
                { title: 'Colaborador', value: 'Colaborador' },
            ],
            permission: {
                readDocument: false,
                addDocument: false,
                deleteDocument: false,
                monitorProgressDocument: false,
                managementCategory: false,
                managementSubcategory: false,
            },
            arrCategory: [],
            arrSubcategory: [],
            dataDialogForm: {
                type: 'R' | 'M',
                title: '',
                open: false,
                id: null,
            },
            dataDialogSave: {
                title: '',
                description: '',
                loading: false,
                open: false
            },
            dataAlertDownload: {
                id: null,
                open: false,
                loading: false,
            },
            dataAlertDelete: {
                id: null,
                open: false,
                loading: false,
            },
            snackbarData: {
                openSnackbar: false,
                description: '',
            },
            typeUser: '',
            arrUsers: [],
            dataSourceProcess: {
                data: [],
                headers: [
                    { 
                        align: 'start',
                        key: 'nombre_categoria', 
                        title: 'Categoría' 
                    },
                    { 
                        key: 'nombre_subcategoria', 
                        title: 'Subcategoría' 
                    },
                    { 
                        key: 'nombre', 
                        title: 'Nombre del Documento' 
                    },
                    { 
                        key: 'perfiles', 
                        title: 'Perfiles' 
                    },
                    { 
                        key: 'estado', 
                        title: 'Estado' 
                    },
                    { 
                        key: 'agregado_por', 
                        title: 'Última Actualización' 
                    },
                    { 
                        key: 'created_at', 
                        title: 'Fecha de Actualización' 
                    },
                    { 
                        key: 'actions', 
                        title: 'Acciones' 
                    },
                    
                ]
            },
        }
    },
    async created() {
        const ENC_PERMISOS = localStorage.getItem('PERMISOS')
        const STR_PERMISOS = atob(ENC_PERMISOS)
        const ARR_PERMISOS = JSON.parse(STR_PERMISOS)
        const PERMISSION = ARR_PERMISOS.find((permission) => permission.modulo === 'M04DOCU')
        for (const element of PERMISSION.endpoints) {
            if (element.nombre === 'M04F01LEDO' && element.permiso === true) {
                this.permission.readDocument = true
            }
            if (element.nombre === 'M04F02AGDO' && element.permiso === true) {
                this.permission.addDocument = true
            }
            if (element.nombre === 'M04F03ELDO' && element.permiso === true) {
                this.permission.deleteDocument = true
            }
            if (element.nombre === 'M04F05MOAG' && element.permiso === true) {
                this.permission.monitorProgressDocument = true
            }
            if (element.nombre === 'M05F1COCA' && element.permiso === true) {
                this.permission.managementCategory = true
            }
            if (element.nombre === 'M06F2COSC' && element.permiso === true) {
                this.permission.managementSubcategory = true
            }
        }

        const ENC_TIPO = localStorage.getItem('TIPO')
        this.typeUser = await EncryptService.decrypt(ENC_TIPO)

        this.isLoading = true
        if (this.typeUser === 'Supervisor' || this.typeUser === 'Administrador') {
            await this.getUsersBySupervisor()
        }
        await this.getCategories()
        await this.getDocuments()
        this.isLoading = false
    },
    methods: {
        getDocuments: async function () {
            this.isLoading = true
            await DocumentsService.getDocuments().then(
                (responseData) => {
                    
                    if (!responseData.error) {
                        let arrTemp = []
                        for (let element of responseData.response) {
                            element.id_categoria = element.id_categoria === null ? 'N/A' : element.id_categoria
                            element.id_subcategoria = element.id_subcategoria === null ? 'N/A' : element.id_subcategoria
                            element.nombre = element.nombre === null ? 'N/A' : element.nombre
                            element.perfiles = element.perfiles === null ? 'N/A' : element.perfiles
                            element.agregado_por = element.editado_por === null ? element.agregado_por : element.editado_por
                            element.created_at = element.updated_at === null ? element.created_at : element.updated_at

                            arrTemp.push(element)
                        }
                        this.dataSource.data = arrTemp
                    } else {
                        this.snackbarData.description = `${responseData.msg}`
                        this.snackbarData.openSnackbar = true
                    }
                }
            )
            this.isLoading = false
        },

        getCategories: async function () {
            this.isLoading = true
            await DocumentsService.getCategories().then(
                async (responseData) => {
                    if (!responseData.error) {
                        this.arrCategory = responseData.response
                    } else {
                        this.snackbarData.description = `${responseData.msg}`
                        this.snackbarData.openSnackbar = true
                    }
                }
            )
            this.isLoading = false
        },

        getSubcategoriesByCategory: async function () {
            this.isLoadingSubcategory = true
            const ID_CATEGORIA = this.formGroup.data.id_categoria
            if (ID_CATEGORIA !== null) {
                const ID_ENC = await EncryptService.encrypt(`${ID_CATEGORIA}`)
                await DocumentsService.getSubcategoriesByCategory(ID_ENC).then(
                    (responseData) => {
                        if (!responseData.error) {
                            this.arrSubcategory = responseData.response
                            if (this.arrSubcategory.length == 0) {
                                this.snackbarData.description = `No hay subcategorías asociadas a la categoría seleccionada`
                                this.snackbarData.openSnackbar = true
                            }
                        } else {
                            this.snackbarData.description = `${responseData.msg}`
                            this.snackbarData.openSnackbar = true
                        }
                    }
                )
            }
            this.isLoadingSubcategory = false
        },

        getUsersBySupervisor: async function () {
            const ID = localStorage.getItem('ID')
            const ENC_ID = await EncryptService.encrypt(`${ID}`)

            await NoticeService.getUsersBySupervisor(ENC_ID).then(
                async (responseData) => {
                    if (!responseData.error) {
                        this.arrUsers = responseData.response
                        this.arrUsers.unshift({id: null, usuario: 'Ninguno'})
                    } else {
                        this.snackbarData.description = `${responseData.msg}`
                        this.snackbarData.openSnackbar = true
                    }
                }
            )
        },

        openForm: function (typeForm) {
            this.dataDialogForm.type = typeForm
            if (typeForm === 'R') {
                this.dataDialogForm.title = `Registro de Documentos`
                this.dataDialogForm.open = true
            } else {
                this.snackbarData.description = `Opción no disponible`
                this.snackbarData.openSnackbar = true
            }
        },

        clearForm: function () {
            this.formGroup.data.id_categoria = null
            this.formGroup.data.id_subcategoria = null
            this.formGroup.data.archivo = null
            this.formGroup.data.perfiles = null
            this.formGroup.data.nombreDocumento = null

            this.dataDialogForm.open = false
            this.dataDialogSave.open = false
        },

        validateForm: function () {
            let id_categoria = this.formGroup.data.id_categoria
            if (id_categoria === null || id_categoria === undefined || id_categoria === '') {
                return true
            }
            /*let id_subcategoria = this.formGroup.data.id_subcategoria
            if (id_subcategoria === null || id_subcategoria === undefined || id_subcategoria === '') {
                return true
            }*/
            let archivo = this.formGroup.data.archivo
            if (archivo === null || archivo === undefined || archivo === '') {
                return true
            }
            let perfiles = this.formGroup.data.perfiles
            if (perfiles === null || perfiles === undefined || perfiles === '') {
                return true
            }

            let nombreDocumento  = this.formGroup.data.nombreDocumento;
            if (nombreDocumento === null || nombreDocumento === undefined || nombreDocumento === '') {
                return true
            }
            return false
        },

        saveForm: function () {
            const TYPE = this.dataDialogForm.type
            if (TYPE === 'R') {
                this.dataDialogSave.title = `Confirmación`
                this.dataDialogSave.description = `¿Está seguro de registrar la información del documento?`
                this.dataDialogForm.open = false
                this.dataDialogSave.open = true
            } else {
                this.snackbarData.description = `Opción no disponible`
                this.snackbarData.openSnackbar = true
            }
        },

        confirmateForm: async function () {
            this.dataDialogSave.loading = true
            const TYPE = this.dataDialogForm.type
            if (TYPE === 'R') {
                this.dataDialogSave.description = `Registrando la información del documento`;
                await this.createDocument()
                this.dataDialogSave.open = false
            } else {
                this.snackbarData.description = `Opción no disponible`
                this.snackbarData.openSnackbar = true
            }
            this.dataDialogSave.loading = false
        },

        createDocument: async function () {
            const REQUEST = await this.createRequestDocument()
            if (REQUEST !== null) {
                await DocumentsService.createDocument(REQUEST).then(
                    async (responseData) => {
                        if (!responseData.error) {
                            this.snackbarData.description = `¡Registro de Documento Exitoso!`
                            this.snackbarData.openSnackbar = true
                            await this.getDocuments()
                        } else {
                            this.snackbarData.description = `${responseData.msg}`
                            this.snackbarData.openSnackbar = true
                        }
                        this.clearForm();
                    }
                )
            }
        },

        createRequestDocument: async function () {
            const formData = new FormData();

            let id_categoria = this.formGroup.data.id_categoria
            id_categoria = id_categoria.toString().trim()
            id_categoria = await EncryptService.encrypt(`${id_categoria}`);

            let id_subcategoria = this.formGroup.data.id_subcategoria
            if (id_subcategoria != null && id_subcategoria != undefined && id_subcategoria != '') {
                id_subcategoria = id_subcategoria.toString().trim()
                id_subcategoria = await EncryptService.encrypt(`${id_subcategoria}`)
            }

            let perfiles = this.formGroup.data.perfiles
            perfiles = perfiles.toString().trim()

            let archivo = this.formGroup.data.archivo
            archivo = archivo[0]

            let nombreDocumento  = this.formGroup.data.nombreDocumento;
            nombreDocumento = await EncryptService.encrypt(`${nombreDocumento}`);

            let agregado_por = localStorage.getItem('USERNAME')

            let despacho = localStorage.getItem('DESPACHO')


            formData.append("id_categoria", id_categoria);
            formData.append("id_subcategoria", id_subcategoria);
            formData.append("perfiles", perfiles);
            formData.append("archivo", archivo);
            formData.append("agregado_por", agregado_por);
            formData.append("despacho", despacho);
            formData.append("nombre", nombreDocumento);

            return formData
        },

        confirmateDownload: function (item) {
            this.dataAlertDownload.id = item.id_documento
            this.dataAlertDownload.open = true
        },

        confirmateDelete: function (item) {
            this.dataAlertDelete.id = item.id_documento
            this.dataAlertDelete.open = true
        },

        deleteDocument: async function  () {
            this.dataAlertDelete.loading = true
            const ID = this.dataAlertDelete.id
            if (ID !== null) {
                const ENC_ID = await EncryptService.encrypt(`${ID}`)
                await DocumentsService.deleteDocument(ENC_ID).then(
                    (responseData) => {
                        if (!responseData.error) {
                            this.snackbarData.description = `!Eliminación del Documento Exitosa!`
                            this.snackbarData.openSnackbar = true
    
                            this.dataAlertDelete.id = null
                            this.dataAlertDelete.open = false
    
                            this.getDocuments()
                        } else {
                            this.snackbarData.description = `${responseData.msg}`
                            this.snackbarData.openSnackbar = true
                        }
                    }
                )
            } else {
                this.snackbarData.description = `Datos incorrectos`
                this.snackbarData.openSnackbar = true
            }
            this.dataAlertDelete.loading = false
        },

        getDocumentURL: async function () {
            this.dataAlertDownload.loading = true
            const ID = this.dataAlertDownload.id
            if (ID !== null) {
                const ENC_ID = await EncryptService.encrypt(`${ID}`)
                const ID_USER = localStorage.getItem('ID')
                const ENC_ID_USER =  await EncryptService.encrypt(`${ID_USER}`)
                await DocumentsService.getDocumentURL(ENC_ID, ENC_ID_USER).then(
                    (responseData) => {
                        if (!responseData.error) {
                            this.snackbarData.description = `!Descarga Exitosa!`
                            this.snackbarData.openSnackbar = true
    
                            this.dataAlertDownload.id = null
                            this.dataAlertDownload.open = false

                            window.open(`${responseData.response}`, '_blank')
    
                        } else {
                            this.snackbarData.description = `${responseData.msg}`
                            this.snackbarData.openSnackbar = true
                        }
                    }
                )
            } else {
                this.snackbarData.description = `Datos incorrectos`
                this.snackbarData.openSnackbar = true
            }
            this.dataAlertDownload.loading = false
        },

        getProgressByUser: async function () {
            if (this.formFilter === null) {
                await this.getDocuments()
                return;
            }
            if (this.formFilter !== undefined && this.formFilter !== '') {
                const ENC_ID = await EncryptService.encrypt(`${this.formFilter}`)
                await DocumentsService.getProgressByUser(ENC_ID).then(
                    async (responseData) => {
                        if (!responseData.error) {
                            this.dataSourceProcess.data = responseData.response
                        } else {
                            this.snackbarData.description = `${responseData.msg}`
                            this.snackbarData.openSnackbar = true
                        }
                    }
                )
            }
        },
    }
}
</script>

<style scoped>
    .v-list-item:hover {
        background-color: #F5F5F5 !important;
        cursor: pointer;
        text-decoration: none;
        color: black;
    }
</style>